import { useMemo } from "react";
import { Source, Layer } from "react-map-gl/mapbox";
import type { PlacePreviewFeature } from "../../../lib/api";
import type { FeatureCollection, Point } from "geojson";
import {
  SELECTED_PLACE_LAYER_ID,
  SELECTED_PLACE_SOURCE_ID,
  selectedPlaceLayout,
  placePaint,
} from "../../../lib/mapConstants";

interface SelectedPlaceLayerProps {
  /** The currently selected place, or null if none */
  place: PlacePreviewFeature | null;
}

/**
 * Renders the selected place with a poi-{type}-selected icon.
 * Always renders (with empty features when no place selected) to maintain consistent layer ordering.
 */
export function SelectedPlaceLayer({ place }: SelectedPlaceLayerProps) {
  const data = useMemo((): FeatureCollection<Point> => {
    if (!place) {
      return { type: "FeatureCollection", features: [] };
    }
    return { type: "FeatureCollection", features: [place] };
  }, [place]);

  return (
    <Source id={SELECTED_PLACE_SOURCE_ID} type="geojson" data={data}>
      <Layer id={SELECTED_PLACE_LAYER_ID} type="symbol" layout={selectedPlaceLayout} paint={placePaint} />
    </Source>
  );
}
